const mapOrderTrackingPreviewRecommendedProduct = product => {
  return {
    id: product.id,
    name: product.name,
    url: product.url,
    image_url: product.image_url,
    from_price: product.from_price,
    discount_type: product.discount_type,
    discount_amount: product.discount_amount,
  }
}

export const transformRequestGetOrderTrackingPreviewRecommendedProducts = params => {
  return {
    page: params.page,
    page_size: params.page_size,
    source: params.source,
    source_value: params.source_value,
  }
}

export const transformResponseOrderTrackingPreviewRecommendedProducts = response => {
  return {
    next: response.next,
    results: response.results.map(mapOrderTrackingPreviewRecommendedProduct),
  }
}
